const translation = {
  currentPlan: 'वर्तमान योजना',
  upgradeBtn: {
    plain: 'योजना अपग्रेड करें',
    encourage: 'अभी अपग्रेड करें',
    encourageShort: 'अपग्रेड करें',
  },
  viewBilling: 'बिलिंग और सब्सक्रिप्शन प्रबंधित करें',
  buyPermissionDeniedTip:
    'सब्सक्राइब करने के लिए कृपया अपने एंटरप्राइज़ व्यवस्थापक से संपर्क करें',
  plansCommon: {
    title: 'आपके लिए सही योजना चुनें',
    yearlyTip: 'वार्षिक सब्सक्राइब करने पर 2 महीने मुफ्त पाएं!',
    mostPopular: 'सबसे लोकप्रिय',
    planRange: {
      monthly: 'मासिक',
      yearly: 'वार्षिक',
    },
    month: 'महीना',
    year: 'साल',
    save: 'बचत करें ',
    free: 'मुफ्त',
    currentPlan: 'वर्तमान योजना',
    contractSales: 'बिक्री से संपर्क करें',
    contractOwner: 'टीम प्रबंधक से संपर्क करें',
    startForFree: 'मुफ्त में शुरू करें',
    getStartedWith: 'इसके साथ शुरू करें ',
    contactSales: 'बिक्री से संपर्क करें',
    talkToSales: 'बिक्री से बात करें',
    modelProviders: 'मॉडल प्रदाता',
    teamMembers: 'टीम के सदस्य',
    annotationQuota: 'एनोटेशन कोटा',
    buildApps: 'ऐप्स बनाएं',
    vectorSpace: 'वेक्टर स्पेस',
    vectorSpaceBillingTooltip:
      'प्रत्येक 1MB लगभग 1.2 मिलियन वर्णों के वेक्टराइज्ड डेटा को संग्रहीत कर सकता है (OpenAI एम्बेडिंग का उपयोग करके अनुमानित, मॉडल में भिन्नता होती है)।',
    vectorSpaceTooltip:
      'वेक्टर स्पेस वह दीर्घकालिक स्मृति प्रणाली है जिसकी आवश्यकता LLMs को आपके डेटा को समझने के लिए होती है।',
    documentsUploadQuota: 'दस्तावेज़ अपलोड कोटा',
    documentProcessingPriority: 'दस्तावेज़ प्रसंस्करण प्राथमिकता',
    documentProcessingPriorityTip:
      'उच्च दस्तावेज़ प्रसंस्करण प्राथमिकता के लिए, कृपया अपनी योजना अपग्रेड करें।',
    documentProcessingPriorityUpgrade:
      'तेजी से गति पर उच्च सटीकता के साथ अधिक डेटा संसाधित करें।',
    priority: {
      'standard': 'मानक',
      'priority': 'प्राथमिकता',
      'top-priority': 'शीर्ष प्राथमिकता',
    },
    logsHistory: 'लॉग इतिहास',
    customTools: 'कस्टम टूल्स',
    unavailable: 'अनुपलब्ध',
    days: 'दिन',
    unlimited: 'असीमित',
    support: 'समर्थन',
    supportItems: {
      communityForums: 'समुदाय फोरम',
      emailSupport: 'ईमेल समर्थन',
      priorityEmail: 'प्राथमिकता ईमेल और चैट समर्थन',
      logoChange: 'लोगो परिवर्तन',
      SSOAuthentication: 'SSO प्रमाणीकरण',
      personalizedSupport: 'व्यक्तिगत समर्थन',
      dedicatedAPISupport: 'समर्पित API समर्थन',
      customIntegration: 'कस्टम एकीकरण और समर्थन',
      ragAPIRequest: 'RAG API अनुरोध',
      bulkUpload: 'दस्तावेजों का थोक अपलोड',
      agentMode: 'एजेंट मोड',
      workflow: 'कार्यप्रवाह',
      llmLoadingBalancing: 'LLM लोड बैलेंसिंग',
      llmLoadingBalancingTooltip:
        'मॉडल्स में कई API कुंजियाँ जोड़ें, प्रभावी रूप से API दर सीमाओं को बायपास करें।',
    },
    comingSoon: 'जल्द आ रहा है',
    member: 'सदस्य',
    memberAfter: 'सदस्य',
    messageRequest: {
      title: 'संदेश क्रेडिट्स',
      tooltip:
        'विभिन्न योजनाओं के लिए संदेश आह्वान कोटा OpenAI मॉडलों का उपयोग करके (gpt4 को छोड़कर)। सीमा से अधिक संदेश आपके OpenAI API कुंजी का उपयोग करेंगे।',
      titlePerMonth: '{{count,number}} संदेश/महीना',
    },
    annotatedResponse: {
      title: 'एनोटेशन कोटा सीमाएं',
      tooltip:
        'प्रतिक्रियाओं का मैन्युअल संपादन और एनोटेशन ऐप्स के लिए अनुकूलन योग्य उच्च-गुणवत्ता वाले प्रश्न-उत्तर क्षमताएं प्रदान करता है। (केवल चैट ऐप्स में लागू)',
    },
    ragAPIRequestTooltip:
      'Dify की केवल ज्ञान आधार प्रसंस्करण क्षमताओं को आह्वान करने वाले API कॉल की संख्या को संदर्भित करता है।',
    receiptInfo:
      'केवल टीम के मालिक और टीम एडमिन सब्सक्राइब कर सकते हैं और बिलिंग जानकारी देख सकते हैं',
    freeTrialTipPrefix: 'साइन अप करें और प्राप्त करें एक',
    teamMember_other: '{{count,number}} टीम सदस्य',
    comparePlanAndFeatures: 'योजना और विशेषताओं की तुलना करें',
    apiRateLimit: 'एपीआई दर सीमा',
    documentsRequestQuota: '{{count,number}}/मिनट ज्ञान अनुरोध दर सीमा',
    self: 'स्व-होस्टेड',
    getStarted: 'शुरू करें',
    annualBilling: 'वार्षिक बिलिंग',
    documentsTooltip: 'ज्ञान डेटा स्रोत से आयात किए गए दस्तावेजों की संख्या पर कोटा।',
    priceTip: 'प्रत्येक कार्यक्षेत्र/',
    cloud: 'क्लाउड सेवा',
    unlimitedApiRate: 'कोई एपीआई दर सीमा नहीं',
    freeTrialTip: '200 ओपनएआई कॉल्स का मुफ्त परीक्षण।',
    documents: '{{count,number}} ज्ञान दस्तावेज़',
    freeTrialTipSuffix: 'कोई क्रेडिट कार्ड की आवश्यकता नहीं है',
    apiRateLimitUnit: '{{count,number}}/दिन',
    teamWorkspace: '{{count,number}} टीम कार्यक्षेत्र',
    apiRateLimitTooltip: 'Dify API के माध्यम से की गई सभी अनुरोधों पर API दर सीमा लागू होती है, जिसमें टेक्स्ट जनरेशन, चैट वार्तालाप, कार्यप्रवाह निष्पादन और दस्तावेज़ प्रसंस्करण शामिल हैं।',
    teamMember_one: '{{count,number}} टीम सदस्य',
    documentsRequestQuotaTooltip: 'यह ज्ञान आधार में एक कार्यक्षेत्र द्वारा प्रति मिनट किए जा सकने वाले कुल कार्यों की संख्या को निर्दिष्ट करता है, जिसमें डेटासेट बनाना, हटाना, अपडेट करना, दस्तावेज़ अपलोड करना, संशोधन करना, संग्रहित करना और ज्ञान आधार अनुरोध शामिल हैं। इस मीट्रिक का उपयोग ज्ञान आधार अनुरोधों के प्रदर्शन का मूल्यांकन करने के लिए किया जाता है। उदाहरण के लिए, यदि एक सैंडबॉक्स उपयोगकर्ता एक मिनट के भीतर 10 लगातार हिट परीक्षण करता है, तो उनके कार्यक्षेत्र को अगले मिनट के लिए निम्नलिखित कार्यों को करने से अस्थायी रूप से प्रतिबंधित किया जाएगा: डेटासेट बनाना, हटाना, अपडेट करना और दस्तावेज़ अपलोड या संशोधन करना।',
  },
  plans: {
    sandbox: {
      name: 'सैंडबॉक्स',
      description: '200 बार GPT मुफ्त ट्रायल',
      includesTitle: 'शामिल हैं:',
      for: 'कोर क्षमताओं का मुफ्त परीक्षण',
    },
    professional: {
      name: 'प्रोफेशनल',
      description:
        'व्यक्तियों और छोटे टीमों के लिए अधिक शक्ति सस्ती दर पर खोलें।',
      includesTitle: 'मुफ्त योजना में सब कुछ, साथ में:',
      for: 'स्वतंत्र डेवलपर्स/छोटे टीमों के लिए',
    },
    team: {
      name: 'टीम',
      description:
        'बिना सीमा के सहयोग करें और शीर्ष स्तरीय प्रदर्शन का आनंद लें।',
      includesTitle: 'प्रोफेशनल योजना में सब कुछ, साथ में:',
      for: 'मध्यम आकार की टीमों के लिए',
    },
    enterprise: {
      name: 'एंटरप्राइज़',
      description:
        'बड़े पैमाने पर मिशन-क्रिटिकल सिस्टम के लिए पूर्ण क्षमताएं और समर्थन प्राप्त करें।',
      includesTitle: 'टीम योजना में सब कुछ, साथ में:',
      features: {
        0: 'उद्योग स्तर के बड़े पैमाने पर वितरण समाधान',
        3: 'अनेक कार्यक्षेत्र और उद्यम प्रबंधक',
        8: 'प्रोफेशनल तकनीकी समर्थन',
        6: 'उन्नत सुरक्षा और नियंत्रण',
        2: 'विशेष उद्यम सुविधाएँ',
        1: 'Commercial License Authorization',
        4: 'SSO',
        5: 'डिफाई पार्टनर्स द्वारा बातचीत किए गए एसएलए',
        7: 'डीफाई द्वारा आधिकारिक रूप से अपडेट और रखरखाव',
      },
      price: 'कस्टम',
      btnText: 'बिक्री से संपर्क करें',
      priceTip: 'वार्षिक बिलिंग केवल',
      for: 'बड़े आकार की टीमों के लिए',
    },
    community: {
      features: {
        2: 'डिफी ओपन सोर्स लाइसेंस के अनुपालन में',
        0: 'सभी मुख्य सुविधाएं सार्वजनिक संग्रह के तहत जारी की गई हैं।',
        1: 'एकल कार्यक्षेत्र',
      },
      description: 'व्यक्तिगत उपयोगकर्ताओं, छोटे टीमों, या गैर-व्यावसायिक परियोजनाओं के लिए',
      for: 'व्यक्तिगत उपयोगकर्ताओं, छोटे टीमों, या गैर-व्यावसायिक परियोजनाओं के लिए',
      includesTitle: 'निःशुल्क सुविधाएँ:',
      btnText: 'समुदाय के साथ आरंभ करें',
      name: 'समुदाय',
      price: 'मुक्त',
    },
    premium: {
      features: {
        2: 'वेब ऐप लोगो और ब्रांडिंग कस्टमाइजेशन',
        3: 'प्राथमिकता ईमेल और चैट समर्थन',
        1: 'एकल कार्यक्षेत्र',
        0: 'विभिन्न क्लाउड प्रदाताओं द्वारा आत्म-प्रबंधित विश्वसनीयता',
      },
      priceTip: 'क्लाउड मार्केटप्लेस के आधार पर',
      name: 'प्रीमियम',
      btnText: 'प्रीमियम प्राप्त करें',
      price: 'स्केलेबल',
      includesTitle: 'समुदाय से सब कुछ, इसके अलावा:',
      for: 'मध्यम आकार के संगठनों और टीमों के लिए',
      description: 'मध्यम आकार के संगठनों और टीमों के लिए',
      comingSoon: 'माइक्रोसॉफ्ट एज़्योर और गूगल क्लाउड समर्थन जल्द ही आ रहा है',
    },
  },
  vectorSpace: {
    fullTip: 'वेक्टर स्पेस पूर्ण है।',
    fullSolution: 'अधिक स्थान प्राप्त करने के लिए अपनी योजना अपग्रेड करें।',
  },
  apps: {
    fullTipLine1: 'अधिक ऐप्स बनाने के लिए',
    fullTipLine2: 'अपनी योजना अपग्रेड करें।',
    fullTip1: 'अधिक ऐप्स बनाने के लिए अपग्रेड करें',
    fullTip2: 'योजना की सीमा पहुँच गई',
    contactUs: 'हमसे संपर्क करें',
    fullTip1des: 'आप इस योजना पर ऐप्स बनाने की सीमा तक पहुँच चुके हैं।',
    fullTip2des: 'अचल अनुप्रयोगों को साफ करने की सिफारिश की जाती है ताकि उपयोग को मुक्त किया जा सके, या हमसे संपर्क करें।',
  },
  annotatedResponse: {
    fullTipLine1: 'अधिक बातचीत को एनोटेट करने के लिए',
    fullTipLine2: 'अपनी योजना अपग्रेड करें।',
    quotaTitle: 'एनोटेशन उत्तर कोटा',
  },
  usagePage: {
    annotationQuota: 'एनोटेशन कोटा',
    buildApps: 'ऐप बनाएं',
    documentsUploadQuota: 'दस्तावेज़ अपलोड कोटा',
    vectorSpace: 'ज्ञान डेटा भंडारण',
    teamMembers: 'टीम के सदस्य',
    vectorSpaceTooltip: 'उच्च गुणवत्ता वाले अनुक्रमण मोड के साथ दस्तावेज़ों के लिए ज्ञान डेटा स्टोरेज संसाधनों का उपभोग होगा। जब ज्ञान डेटा स्टोरेज सीमा तक पहुँच जाएगा, तो नए दस्तावेज़ नहीं अपलोड किए जाएंगे।',
  },
  teamMembers: 'टीम के सदस्य',
}

export default translation
